export enum ActionType {
    SELF_ORDER_ERROR="SELF_ORDER_ERROR"
}

interface ISelfOrderError {
    type: ActionType.SELF_ORDER_ERROR,
    error: string
}

export type Action = ISelfOrderError;